import { UrlHashHandler } from "../shared/UrlHashHandler";
import { get, writable } from "svelte/store";
import { appManager } from "../AppManager";
import { TestManager } from "./test/TestManager";
import { EditManager } from "./edit/EditManager";
export class ScenarioManager {
    constructor(options, id) {
        this.dataLoadedStore = writable(false);
        this.data = writable(undefined);
        this.tripScenarios = writable([]);
        this.readyStore = writable(false);
        this.viewStore = writable("test");
        this.branchCommitId = writable(undefined);
        this.otherScenarios = writable(undefined);
        this.id = id;
        this.testManager = new TestManager(this, {
            mapillaryApiKey: options.mapillaryApiKey,
            maptilerApiKey: options.maptilerApiKey,
            profiles: options.profiles,
        });
        this.editManager = new EditManager(this, this.testManager.getMapViewStore());
        this.mapHashHandler = new UrlHashHandler("map");
        this.viewStore.subscribe(async (v) => {
            if (v !== "test")
                return;
            const data = get(this.data);
            if (typeof data === "undefined")
                return;
            const branchCommitId = await appManager.api.edit.getLatestCommitForBranch({
                accessToken: await appManager.api.getAccessToken(),
                branchId: data.branchId
            });
            this.branchCommitId.set(branchCommitId);
        });
    }
    async initialize() {
        // get the scenario.
        const data = await appManager.api.projects.getScenario({
            accessToken: await appManager.api.getAccessToken(),
            id: this.id
        });
        this.data.set(data);
        // fetch the latest branch commit to know what data we are working with.
        const branchCommitId = await appManager.api.edit.getLatestCommitForBranch({
            accessToken: await appManager.api.getAccessToken(),
            branchId: data.branchId
        });
        this.branchCommitId.set(branchCommitId);
        // get the project to fill the other scenario list.
        const project = await appManager.api.projects.getProject({
            accessToken: await appManager.api.getAccessToken(),
            id: data.project.id,
        });
        const result = [];
        for (const s of project.scenarios) {
            const branchCommitId = await appManager.api.edit.getLatestCommitForBranch({
                accessToken: await appManager.api.getAccessToken(),
                branchId: s.branchId
            });
            result.push({
                commitId: branchCommitId,
                isCurrent: s.id === data.id,
                isIdentical: branchCommitId === get(this.branchCommitId),
                scenario: s
            });
        }
        this.otherScenarios.set(result.sort((x, y) => x.scenario.functionalName.localeCompare(y.scenario.functionalName)));
        this.tripScenarios.set([data.tripScenarioModel]);
        this.readyStore.set(true);
    }
    getTripScenariosStore() {
        return this.tripScenarios;
    }
    getReadyStore() {
        return this.readyStore;
    }
    getTestManager() {
        return this.testManager;
    }
    getEditManager() {
        return this.editManager;
    }
    getDataLoadedStore() {
        return this.dataLoadedStore;
    }
    getViewStore() {
        return this.viewStore;
    }
    getData() {
        return this.data;
    }
    /**
     * Gets the branch commit id store
     *
     * @returns The branch commit id store.
     */
    getBranchCommitId() {
        return this.branchCommitId;
    }
    async getScenario() {
        if (typeof get(this.data) === "undefined") {
            this.data.set(await appManager.api.projects.getScenario({
                accessToken: await appManager.api.getAccessToken(),
                id: this.id
            }));
        }
        return get(this.data);
    }
    /**
     * Gets metadata about previous commits (aka changesets) made on this scenario
     */
    async getCommits() {
        const scenario = await this.getScenario();
        const branchId = scenario.branchId;
        return await appManager.api.edit.getCommitsInfo({
            branchId,
            accessToken: await appManager.api.getAccessToken()
        });
    }
    /**
     * Gets the other scenarios in this project.
     *
     * @returns The scenarios sorted by functional name.
     */
    getOtherScenarios() {
        return this.otherScenarios;
    }
}
